export const state_options = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AS", label: "American Samoa" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "DC", label: "District Of Columbia" },
    { value: "FM", label: "Federated States Of Micronesia" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "GU", label: "Guam" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MH", label: "Marshall Islands" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "MP", label: "Northern Mariana Islands" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PW", label: "Palau" },
    { value: "PA", label: "Pennsylvania" },
    { value: "PR", label: "Puerto Rico" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VI", label: "Virgin Islands" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" }
]

export const country_options = [{ value: 'af', label: 'Afghanistan' },
{ value: 'ax', label: 'Åland Islands' },
{ value: 'al', label: 'Albania' },
{ value: 'dz', label: 'Algeria' },
{ value: 'as', label: 'American Samoa' },
{ value: 'ad', label: 'AndorrA' },
{ value: 'ao', label: 'Angola' },
{ value: 'ai', label: 'Anguilla' },
{ value: 'aq', label: 'Antarctica' },
{ value: 'ag', label: 'Antigua and Barbuda' },
{ value: 'ar', label: 'Argentina' },
{ value: 'am', label: 'Armenia' },
{ value: 'aw', label: 'Aruba' },
{ value: 'au', label: 'Australia' },
{ value: 'at', label: 'Austria' },
{ value: 'az', label: 'Azerbaijan' },
{ value: 'bs', label: 'Bahamas' },
{ value: 'bh', label: 'Bahrain' },
{ value: 'bd', label: 'Bangladesh' },
{ value: 'bb', label: 'Barbados' },
{ value: 'by', label: 'Belarus' },
{ value: 'be', label: 'Belgium' },
{ value: 'bz', label: 'Belize' },
{ value: 'bj', label: 'Benin' },
{ value: 'bm', label: 'Bermuda' },
{ value: 'bt', label: 'Bhutan' },
{ value: 'bo', label: 'Bolivia' },
{ value: 'ba', label: 'Bosnia and Herzegovina' },
{ value: 'bw', label: 'Botswana' },
{ value: 'bv', label: 'Bouvet Island' },
{ value: 'br', label: 'Brazil' },
{ value: 'io', label: 'British Indian Ocean Territory' },
{ value: 'bn', label: 'Brunei Darussalam' },
{ value: 'bg', label: 'Bulgaria' },
{ value: 'bf', label: 'Burkina Faso' },
{ value: 'bi', label: 'Burundi' },
{ value: 'kh', label: 'Cambodia' },
{ value: 'cm', label: 'Cameroon' },
{ value: 'ca', label: 'Canada' },
{ value: 'cv', label: 'Cape Verde' },
{ value: 'ky', label: 'Cayman Islands' },
{ value: 'cf', label: 'Central African Republic' },
{ value: 'td', label: 'Chad' },
{ value: 'cl', label: 'Chile' },
{ value: 'cn', label: 'China' },
{ value: 'cx', label: 'Christmas Island' },
{ value: 'cc', label: 'Cocos (Keeling) Islands' },
{ value: 'co', label: 'Colombia' },
{ value: 'km', label: 'Comoros' },
{ value: 'cg', label: 'Congo' },
{ value: 'cd', label: 'Congo, The Democratic Republic of the' },
{ value: 'ck', label: 'Cook Islands' },
{ value: 'cr', label: 'Costa Rica' },
{
    value: 'ci', label: "Cote D'Ivoire"
},
{ value: 'hr', label: 'Croatia' },
{ value: 'cu', label: 'Cuba' },
{ value: 'cy', label: 'Cyprus' },
{ value: 'cz', label: 'Czech Republic' },
{ value: 'dk', label: 'Denmark' },
{ value: 'dj', label: 'Djibouti' },
{ value: 'dm', label: 'Dominica' },
{ value: 'do', label: 'Dominican Republic' },
{ value: 'ec', label: 'Ecuador' },
{ value: 'eg', label: 'Egypt' },
{ value: 'sv', label: 'El Salvador' },
{ value: 'gq', label: 'Equatorial Guinea' },
{ value: 'er', label: 'Eritrea' },
{ value: 'ee', label: 'Estonia' },
{ value: 'et', label: 'Ethiopia' },
{ value: 'fk', label: 'Falkland Islands (Malvinas)' },
{ value: 'fo', label: 'Faroe Islands' },
{ value: 'fj', label: 'Fiji' },
{ value: 'fi', label: 'Finland' },
{ value: 'fr', label: 'France' },
{ value: 'gf', label: 'French Guiana' },
{ value: 'pf', label: 'French Polynesia' },
{ value: 'tf', label: 'French Southern Territories' },
{ value: 'ga', label: 'Gabon' },
{ value: 'gm', label: 'Gambia' },
{ value: 'ge', label: 'Georgia' },
{ value: 'de', label: 'Germany' },
{ value: 'gh', label: 'Ghana' },
{ value: 'gi', label: 'Gibraltar' },
{ value: 'gr', label: 'Greece' },
{ value: 'gl', label: 'Greenland' },
{ value: 'gd', label: 'Grenada' },
{ value: 'gp', label: 'Guadeloupe' },
{ value: 'gu', label: 'Guam' },
{ value: 'gt', label: 'Guatemala' },
{ value: 'gg', label: 'Guernsey' },
{ value: 'gn', label: 'Guinea' },
{ value: 'gw', label: 'Guinea-Bissau' },
{ value: 'gy', label: 'Guyana' },
{ value: 'ht', label: 'Haiti' },
{ value: 'hm', label: 'Heard Island and Mcdonald Islands' },
{ value: 'va', label: 'Holy See (Vatican City State)' },
{ value: 'hn', label: 'Honduras' },
{ value: 'hk', label: 'Hong Kong' },
{ value: 'hu', label: 'Hungary' },
{ value: 'is', label: 'Iceland' },
{ value: 'in', label: 'India' },
{ value: 'id', label: 'Indonesia' },
{ value: 'ir', label: 'Iran, Islamic Republic Of' },
{ value: 'iq', label: 'Iraq' },
{ value: 'ie', label: 'Ireland' },
{ value: 'im', label: 'Isle of Man' },
{ value: 'il', label: 'Israel' },
{ value: 'it', label: 'Italy' },
{ value: 'jm', label: 'Jamaica' },
{ value: 'jp', label: 'Japan' },
{ value: 'je', label: 'Jersey' },
{ value: 'jo', label: 'Jordan' },
{ value: 'kz', label: 'Kazakhstan' },
{ value: 'ke', label: 'Kenya' },
{ value: 'ki', label: 'Kiribati' },
{
    value: 'kp', label: "Korea, Democratic People's Republic of"
},
{ value: 'kr', label: 'Korea, Republic of' },
{ value: 'kw', label: 'Kuwait' },
{ value: 'kg', label: 'Kyrgyzstan' },
{
    value: 'la', label: "Lao People's Democratic Republic"
},
{ value: 'lv', label: 'Latvia' },
{ value: 'lb', label: 'Lebanon' },
{ value: 'ls', label: 'Lesotho' },
{ value: 'lr', label: 'Liberia' },
{ value: 'ly', label: 'Libyan Arab Jamahiriya' },
{ value: 'li', label: 'Liechtenstein' },
{ value: 'lt', label: 'Lithuania' },
{ value: 'lu', label: 'Luxembourg' },
{ value: 'mo', label: 'Macao' },
{ value: 'mk', label: 'Macedonia, The Former Yugoslav Republic of' },
{ value: 'mg', label: 'Madagascar' },
{ value: 'mw', label: 'Malawi' },
{ value: 'my', label: 'Malaysia' },
{ value: 'mv', label: 'Maldives' },
{ value: 'ml', label: 'Mali' },
{ value: 'mt', label: 'Malta' },
{ value: 'mh', label: 'Marshall Islands' },
{ value: 'mq', label: 'Martinique' },
{ value: 'mr', label: 'Mauritania' },
{ value: 'mu', label: 'Mauritius' },
{ value: 'yt', label: 'Mayotte' },
{ value: 'mx', label: 'Mexico' },
{ value: 'fm', label: 'Micronesia, Federated States of' },
{ value: 'md', label: 'Moldova, Republic of' },
{ value: 'mc', label: 'Monaco' },
{ value: 'mn', label: 'Mongolia' },
{ value: 'ms', label: 'Montserrat' },
{ value: 'ma', label: 'Morocco' },
{ value: 'mz', label: 'Mozambique' },
{ value: 'mm', label: 'Myanmar' },
{ value: 'na', label: 'Namibia' },
{ value: 'nr', label: 'Nauru' },
{ value: 'np', label: 'Nepal' },
{ value: 'nl', label: 'Netherlands' },
{ value: 'an', label: 'Netherlands Antilles' },
{ value: 'nc', label: 'New Caledonia' },
{ value: 'nz', label: 'New Zealand' },
{ value: 'ni', label: 'Nicaragua' },
{ value: 'ne', label: 'Niger' },
{ value: 'ng', label: 'Nigeria' },
{ value: 'nu', label: 'Niue' },
{ value: 'nf', label: 'Norfolk Island' },
{ value: 'mp', label: 'Northern Mariana Islands' },
{ value: 'no', label: 'Norway' },
{ value: 'om', label: 'Oman' },
{ value: 'pk', label: 'Pakistan' },
{ value: 'pw', label: 'Palau' },
{ value: 'ps', label: 'Palestinian Territory, Occupied' },
{ value: 'pa', label: 'Panama' },
{ value: 'pg', label: 'Papua New Guinea' },
{ value: 'py', label: 'Paraguay' },
{ value: 'pe', label: 'Peru' },
{ value: 'ph', label: 'Philippines' },
{ value: 'pn', label: 'Pitcairn' },
{ value: 'pl', label: 'Poland' },
{ value: 'pt', label: 'Portugal' },
{ value: 'pr', label: 'Puerto Rico' },
{ value: 'qa', label: 'Qatar' },
{ value: 're', label: 'Reunion' },
{ value: 'ro', label: 'Romania' },
{ value: 'ru', label: 'Russian Federation' },
{ value: 'rw', label: 'RWANDA' },
{ value: 'sh', label: 'Saint Helena' },
{ value: 'kn', label: 'Saint Kitts and Nevis' },
{ value: 'lc', label: 'Saint Lucia' },
{ value: 'pm', label: 'Saint Pierre and Miquelon' },
{ value: 'vc', label: 'Saint Vincent and the Grenadines' },
{ value: 'ws', label: 'Samoa' },
{ value: 'sm', label: 'San Marino' },
{ value: 'st', label: 'Sao Tome and Principe' },
{ value: 'sa', label: 'Saudi Arabia' },
{ value: 'sn', label: 'Senegal' },
{ value: 'cs', label: 'Serbia and Montenegro' },
{ value: 'sc', label: 'Seychelles' },
{ value: 'sl', label: 'Sierra Leone' },
{ value: 'sg', label: 'Singapore' },
{ value: 'sk', label: 'Slovakia' },
{ value: 'si', label: 'Slovenia' },
{ value: 'sb', label: 'Solomon Islands' },
{ value: 'so', label: 'Somalia' },
{ value: 'za', label: 'South Africa' },
{ value: 'gs', label: 'South Georgia and the South Sandwich Islands' },
{ value: 'es', label: 'Spain' },
{ value: 'lk', label: 'Sri Lanka' },
{ value: 'sd', label: 'Sudan' },
{ value: 'sr', label: 'Suriname' },
{ value: 'sj', label: 'Svalbard and Jan Mayen' },
{ value: 'sz', label: 'Swaziland' },
{ value: 'se', label: 'Sweden' },
{ value: 'ch', label: 'Switzerland' },
{ value: 'sy', label: 'Syrian Arab Republic' },
{ value: 'tw', label: 'Taiwan, Province of China' },
{ value: 'tj', label: 'Tajikistan' },
{ value: 'tz', label: 'Tanzania, United Republic of' },
{ value: 'th', label: 'Thailand' },
{ value: 'tl', label: 'Timor-Leste' },
{ value: 'tg', label: 'Togo' },
{ value: 'tk', label: 'Tokelau' },
{ value: 'to', label: 'Tonga' },
{ value: 'tt', label: 'Trinidad and Tobago' },
{ value: 'tn', label: 'Tunisia' },
{ value: 'tr', label: 'Turkey' },
{ value: 'tm', label: 'Turkmenistan' },
{ value: 'tc', label: 'Turks and Caicos Islands' },
{ value: 'tv', label: 'Tuvalu' },
{ value: 'ug', label: 'Uganda' },
{ value: 'ua', label: 'Ukraine' },
{ value: 'ae', label: 'United Arab Emirates' },
{ value: 'gb', label: 'United Kingdom' },
{ value: 'us', label: 'United States' },
{ value: 'um', label: 'United States Minor Outlying Islands' },
{ value: 'uy', label: 'Uruguay' },
{ value: 'uz', label: 'Uzbekistan' },
{ value: 'vu', label: 'Vanuatu' },
{ value: 've', label: 'Venezuela' },
{ value: 'vn', label: 'Viet Nam' },
{ value: 'vg', label: 'Virgin Islands, British' },
{ value: 'vi', label: 'Virgin Islands, U.S.' },
{ value: 'wf', label: 'Wallis and Futuna' },
{ value: 'eh', label: 'Western Sahara' },
{ value: 'ye', label: 'Yemen' },
{ value: 'zm', label: 'Zambia' },
{ value: 'zw', label: 'Zimbabwe' }];

export const userCountryOptions: Record<string, string> = {
    'us': 'United States',
    'au': 'Australia',
    'cn': 'China',
    'fr': 'France',
    'kr': 'Korea',
    'sg': 'Singapore'
}